import { notification, Select } from "antd";

import React, { useCallback, useEffect, useRef, useState } from "react";
import TableNhapKhoList from "./TableNhapKhoList";
import ModalNhapKho from "./ModalNhapKho";
import { useDispatch, useSelector } from "react-redux";
import { getDSNhapXuat } from "store/slices/sale/nhapxuatSlice";
import moment from "moment";
import { SystemButtonSource } from "constants";
import MeditechTablePage, { FilterComponent } from "components/table-layout";
import DocumentViewer from "constants/DocumentViewer";
import { getAllDmdonvitinh, getDmKk } from "store/slices/sale/danhmucSlice";
import KhNccSelect from "views/app-views/common/khachHangNCC";
import { getCateDinhKhoan } from "store/slices/finance/dinhKhoanCategorySlice";
import { getListDonViXuatHDDT } from "store/slices/sale/nhapkhoSlice";
import UploadFileInvoiceModal from "./importInvoice";
import ModelCopyPhieuNhap from "./copyPhieuNhapThueSangNoiBo";
import { useLocation } from "react-router-dom";

const initSearch = {
  startDate: moment().startOf("month"),
  endDate: moment().endOf("month"),
  searchText: null,
  loai: 1,
  luanchuyen: false,
  makk: null,
  makkgiao: null,
  daDuyet: null,
  branchId: null,
};
export const initNhapKhoCt = {
  action: "initial",
  isRequired: true,
};
export const ETrangThai = [
  {
    value: true,
    label: "Đã duyệt",
  },
  {
    value: false,
    label: "Chưa duyệt",
  },
];
const NhapKhoList = ({ queryId, openModalDetail }) => {
  const dispatch = useDispatch();
  const [visibleModal, setVisibleModal] = useState(false);
  const { permitList, profile } = useSelector((state) => state.auth);
  const [nhapKhoId, setNhapKhoId] = useState(null);
  const [ngaynhap, setNgaynhap] = useState(null);
  const [maKknhap, setMaKknhap] = useState(null);
  const [isVisibleCopy, setIsVisibleCopy] = useState(null);
  const [record, setRecord] = useState({});
  const { nhapXuatList, loading, nhapXuatDetail } = useSelector(
    (state) => state.nhapXuatSale,
  );
  const { ListDonViXuatHDDT } = useSelector((state) => state.nhapKhoSale);
  const searchFormRef = useRef({ ...initSearch });
  const [searchFormData, setSearchFormData] = useState(searchFormRef.current);
  const { nhapKhoCTList } = useSelector((state) => state.nhapKhoSale);
  const [isprinter, setIsPrinter] = useState(false);
  const [printData, setPrintData] = useState({});
  const [idPhieu, setIdPhieu] = useState(null);
  const { dmKkList } = useSelector((state) => state.danhMucSale);
  const [api, contextHolder] = notification.useNotification();
  const isThue = useLocation().pathname.includes("thue");

  const modalUploadRef = useRef(null);

  const openNotification = (type, placement, message) => {
    api[type]({
      message: message,
      placement,
    });
  };
  useEffect(() => {
    dispatch(getAllDmdonvitinh({}));
  }, [dispatch]);

  useEffect(() => {
    if (openModalDetail) {
      setVisibleModal(openModalDetail);
      setIdPhieu(queryId);
    }
  }, [queryId, openModalDetail]);

  const reloadData = useCallback(() => {
    searchFormRef.current = { ...searchFormRef.current, isThue };
    dispatch(getDSNhapXuat(searchFormRef.current));
  }, [dispatch, isThue]);

  useEffect(() => {
    dispatch(getDmKk());
    dispatch(getCateDinhKhoan());
    dispatch(getListDonViXuatHDDT());
    reloadData();
  }, [dispatch, reloadData]);

  const searchHandle = (dataSearch) => {
    searchFormRef.current = { ...searchFormRef.current, ...dataSearch };
    setSearchFormData({ ...searchFormRef.current });
    reloadData();
  };
  const onRenderSearchView = () => {
    return (
      <FilterComponent
        datasource={searchFormData}
        onSearchImmediate={searchHandle}
        renderInputSearch
        renderDatePicker
      >
        <Select
          key="makk"
          data-field="makk"
          style={{ width: "100%", minWidth: 280 }}
          placeholder="Kho nhập"
          options={dmKkList?.filter((x) => x.maloai === 1)}
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        />
        <KhNccSelect
          style={{ width: "100%", minWidth: 280 }}
          key="makkgiao"
          data-field="makkgiao"
          placeholder="Đơn vị giao"
          allowClear
        />
        <Select
          key="branchId"
          data-field="branchId"
          style={{ width: "100%", minWidth: 280 }}
          placeholder="Đơn vị"
          allowClear
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={profile?.branchInfos
            .filter((f) => ListDonViXuatHDDT.includes(f.branchId))
            .map((m) => ({
              value: m.branchId,
              label: m.branchName,
            }))}
        />
        <Select
          key="daDuyet"
          data-field="daDuyet"
          style={{ width: "100%", minWidth: 100 }}
          placeholder="Trạng thái"
          options={ETrangThai}
          allowClear
        />
        <Select
          key="daDuyet"
          data-field="daDuyet"
          style={{ width: "100%", minWidth: 100 }}
          placeholder="Trạng thái"
          options={ETrangThai}
          allowClear
        />
      </FilterComponent>
    );
  };

  const onDeleteHandler = (id) => {};

  const onOpenDetailHandler = (id) => {
    //setDoanKhamId(id);
    setVisibleModal(true);
  };

  const getRightButton = (isLocked) => {
    const arr = [];
    if (isLocked) {
      arr.push({
        keyName: SystemButtonSource.addBtn,
        title: "Thêm",
        showMore: false,
        // disable: !allowAddNew,
      });
      //isThue &&
      arr.push({
        keyName: SystemButtonSource.importBtn,
        title: "Import",
        showMore: true,
        tooltipText: "Import phiếu nhập từ File hóa đơn",
        // disable: !allowAddNew,
      });
    }
    return arr;
  };

  const onRightTopBtnHandler = (key) => {
    switch (key) {
      case SystemButtonSource.addBtn:
        setVisibleModal((prev) => !prev);
        break;
      case SystemButtonSource.importBtn:
        modalUploadRef.current.showModal({}, () => {});
        break;
      default:
        break;
    }
  };
  return (
    <>
      {contextHolder}
      <MeditechTablePage
        tableTitle={`Quản lý nhập kho ${isThue ? "thuế" : "nội bộ"}`}
        btnHeaderRightSource={getRightButton(true)}
        btnHeaderRightSourceHandle={onRightTopBtnHandler}
        onRenderSearchView={onRenderSearchView}
      >
        <TableNhapKhoList
          loading={loading}
          setNhapKhoId={setNhapKhoId}
          nhapXuatList={nhapXuatList}
          reloadData={() => reloadData()}
          setVisibleModal={setVisibleModal}
          visibleModal={visibleModal}
          permitList={permitList}
          onOpenDetail={onOpenDetailHandler}
          onDelete={onDeleteHandler}
          setIsPrinter={setIsPrinter}
          setPrintData={setPrintData}
          setMaKknhap={setMaKknhap}
          maKknhap={maKknhap}
          setNgaynhap={setNgaynhap}
          ngaynhap={ngaynhap}
          isThue={isThue}
          setIsVisibleCopy={setIsVisibleCopy}
          setRecord={setRecord}
        />
      </MeditechTablePage>

      <ModalNhapKho
        visibleModal={visibleModal}
        loading={false}
        setVisibleModal={setVisibleModal}
        nhapKhoId={nhapKhoId}
        setNhapKhoId={setNhapKhoId}
        idPhieu={idPhieu}
        setIdPhieu={setIdPhieu}
        nhapXuatDetail={nhapXuatDetail}
        reloadData={() => reloadData()}
        permitList={permitList}
        nhapKhoCTList={nhapKhoCTList}
        openNotification={openNotification}
        dmKkList={dmKkList}
        setIsPrinter={setIsPrinter}
        setPrintData={setPrintData}
        setMaKknhap={setMaKknhap}
        maKknhap={maKknhap}
        setNgaynhap={setNgaynhap}
        ngaynhap={ngaynhap}
        isThue={isThue}
        profile={profile}
        ListDonViXuatHDDT={ListDonViXuatHDDT}
      />
      <DocumentViewer
        openModel={isprinter}
        setIsPrinter={setIsPrinter}
        soPhieu={printData.sophieu}
        idPhieu={printData.idphieu}
        setPrintData={setPrintData}
        param={{
          manx: (printData.manx || 0).toString(),
          tenkkgiao: (printData.tenkkgiao || "").toString(),
          tenkknhan: (printData.tenkknhan || "").toString(),
          ct: "2",
        }}
        tenMauIn={"NhapXuat.rptPhieuNhapKho"}
        loaiPhieu={"NhapXuat"}
        tieuDe={`In phiếu nhập ${printData.sophieu}`}
      />

      <UploadFileInvoiceModal
        ref={modalUploadRef}
        reloadData={reloadData}
        setVisibleModal={setVisibleModal}
        setNhapKhoId={setNhapKhoId}
        ListDonViXuatHDDT={ListDonViXuatHDDT}
        isThue={isThue}
      />

      {isVisibleCopy && (
        <ModelCopyPhieuNhap
          isVisibleCopy={isVisibleCopy}
          setIsVisibleCopy={setIsVisibleCopy}
          record={record}
        />
      )}
    </>
  );
};

export default NhapKhoList;
